"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.case$ = void 0;
const condp_1 = require("./condp");
function case$(v, ...args) {
    return condp_1.condp((a) => a === v, v, ...args);
    // const retIdx = args.findIndex((test, idx) => even(idx) && test === v) + 1;
    // if (retIdx) return args[retIdx];
    // if (odd(args.length)) return args[args.length - 1]
    // throw new IllegalArgumentException
}
exports.case$ = case$;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FzZSQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY2FzZSQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQWdDO0FBOEJoQyxTQUFnQixLQUFLLENBQUMsQ0FBTSxFQUFFLEdBQUcsSUFBVztJQUN4QyxPQUFPLGFBQUssQ0FBQyxDQUFDLENBQU0sRUFBRSxFQUFFLENBQUMsQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLEVBQUUsR0FBRyxJQUFJLENBQUMsQ0FBQTtJQUM3Qyw2RUFBNkU7SUFDN0UsbUNBQW1DO0lBQ25DLHFEQUFxRDtJQUVyRCxxQ0FBcUM7QUFDekMsQ0FBQztBQVBELHNCQU9DIn0=